import React from 'react';
import ReactDOM from 'react-dom/client';
import './style/index.css'
import ComingSoon from './components/ComingSoon';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ComingSoon />
  </React.StrictMode>
);

